const encodeForUrl = require('./encodeForUrl')
const offerSlug = require('./offerSlug')
const resolveLinkBase = require('./offerResolveLinkBase')

// „/” w wartości (np. model „TGX 26/460”) dzieliłoby segment adresu.
const segment = (text) => (text ? String(text).replace(/\//g, '-') : text)

const offerLink = (offer, encode = true, newScheme = shouldUseNewScheme(offer)) => {
    const linkBase = resolveLinkBase(offer)

    if (!linkBase) return '/'

    const tracking = offer.tracking || {}
    const price = offer.price || {}

    const id = offer._shortid
    const lang = tracking.lang && tracking.lang.toLowerCase() || 'pl'
    const city = encodeForUrl(segment(tracking.city) || 'bez-lokalizacji', encode)
    const slug = encodeForUrl(offerSlug(offer) || 'bez-tytulu', encode)

    const isRent = price.rent
    if (isRent) {
        return [linkBase, slug, id, lang].join('/')
    }

    const isMakeModelBased = Boolean(offer.make)
    if (isMakeModelBased) {
        // marka i model z ogłoszenia — ten sam adres na liście i na stronie
        const make = encodeForUrl(segment(offer.make) || 'bez-marki', encode)
        const model = encodeForUrl(segment(offer.model) || 'bez-modelu', encode)

        return (newScheme
            ? [linkBase, 'oferta', make, model, id, lang]
            : [linkBase, make, model, city, slug, id, lang]).join('/')

    } else {
        return (newScheme
            ? [linkBase, 'oferta', id, lang]
            : [linkBase, slug, id, lang]).join('/')
    }
}


function shouldUseNewScheme (offer) {
    const { tracking } = offer || {}
    const { newUrl } = tracking || {}
    return Boolean(newUrl)
}

module.exports = offerLink